import React from 'react';
import ReviewLayout from '../Templates/ReviewLayout';

const SecondApprover = () => {
    const verticalMenuItems = [
        { key: '1', title: 'ACE - Individual Awards', path: '/review/level2/individual' },
        { key: '2', title: 'ACE - Team Awards', path: '/review/level2/team' },
    ];

    return (
        <ReviewLayout
            subtitle="ELT Review"
            stage="2"
            stageName="Individual Award Nominees"
            verticalMenuItems={verticalMenuItems}
            currentStage={3}
        />
    );
};

export default SecondApprover;
